/**
 * Per-viewer conveniences kept in localStorage — a calendar scale, a board layout. A page must
 * render the same without them: storage can be blocked, cleared or full, so a read falls back
 * and a write that fails is only reported.
 */
import { reportError } from './report-error';

/** The value stored under `<scope>:<key>` if it is one of `allowed`, else `fallback`. */
export function remembered<T extends string>(
  scope: string,
  key: string,
  allowed: readonly T[],
  fallback: T,
): T {
  try {
    const stored = localStorage.getItem(`${scope}:${key}`);
    return allowed.includes(stored as T) ? (stored as T) : fallback;
  } catch (error) {
    reportError(scope, error, { reading: key });
    return fallback;
  }
}

export function remember(scope: string, key: string, value: string): void {
  try {
    localStorage.setItem(`${scope}:${key}`, value);
  } catch (error) {
    // Storage blocked: the choice just won't survive a reload.
    reportError(scope, error, { writing: key });
  }
}
